import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const MembershipModal = ({ membership, onClose }) => {
  // Identify dynamic sections (arrays of objects)
  const dynamicSections = Object.entries(membership)
    .filter(([key, value]) => Array.isArray(value) && value.length > 0 && typeof value[0] === "object");

  // Format Firestore timestamp safely
  const formatTimestamp = (ts) => {
    if (!ts) return "N/A";
    if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleString();
    if (typeof ts.toDate === "function") return ts.toDate().toLocaleString();
    return String(ts);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl w-11/12 md:w-2/3 lg:w-1/2 p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        {/* Header */}
        <div className="mb-6">
          {membership.subSGloopData?.clubImage && (
            <img
              src={membership.subSGloopData.clubImage}
              alt={membership.subSGloopData?.subGroupName}
              className="w-full h-56 object-cover rounded-xl mb-4"
            />
          )}
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            {membership.subSGloopData?.subGroupName || "Membership"}
          </h2>
          <p className="text-gray-500 text-sm">
            Joined on: {formatTimestamp(membership.createdAt)}
          </p>
        </div>

        {/* Fixed Fields */}
        <div className="space-y-3 mb-6">
          <p><span className="font-semibold">Name:</span> {membership.Name}</p>
          <p><span className="font-semibold">Email:</span> {membership.Email}</p>
          <p><span className="font-semibold">Contact:</span> {membership.Contact}</p>
          {membership["Postal Code"] && (
            <p><span className="font-semibold">Postal Code:</span> {membership["Postal Code"]}</p>
          )}
        </div>

        {/* Dynamic Fields */}
        {dynamicSections.map(([sectionName, items]) => (
          <div key={sectionName} className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">{sectionName}</h3>
            {items.map((item, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-xl p-3 mb-2 bg-gray-50"
              >
                {Object.entries(item).map(([field, value]) => (
                  <p key={field} className="text-gray-700">
                    <span className="font-semibold">{field}:</span> {value}
                  </p>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipModal;
